<template>
  <b-link class="btn file-download-btn" @click="handleClick">
    <b-icon icon="paperclip" scale="0.75" rotate="45" />
    &nbsp;
    <span class="file-name">{{ fileName }}</span>
    &nbsp;
    <span class="file-size">({{ fileSize }})</span>
  </b-link>
</template>

<script>
export default {
  name: 'File',

  props: {
    fileName: {
      default() {
        return ''
      }
    },
    fileSize: {
      default() {
        return ''
      }
    }
  },

  methods: {
    handleClick() {
      this.$emit('click')
    }
  }
}
</script>

<style scoped>
.file-name {
  color: #007bff;
  font-size: 14px;
}
.file-size {
  font-size: 14px;
}

.file-download-btn {
  border: 1px solid #ddd;
}

.file-download-btn:hover {
  opacity: 0.9;
}
</style>
